unit DonationDefaults;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WebForm.Core, Vcl.StdCtrls, WEBLib.StdCtrls,
  Vcl.Controls, WEBLib.ExtCtrls, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset;

type
  TDonationDefaultsForm = class(TCoreWebForm)
    PaymentMethodDefaultCombo: TLookupComboBox;
    AnalysisCode2DefaultCombo: TLookupComboBox;
    AnalysisCode1DefaultCombo: TLookupComboBox;
    AmountDefaultEdit: TEdit;
    DayOfMonthDefaultEdit: TEdit;
    DonationKindDefaultCombo: TLookupComboBox;
    SaveDefaultButton: TButton;
    CancelDefaultButton: TButton;
    CloseDefaultButton: TButton;
    DonationDefaults: TXDataWebDataSet;
    DonationDefaultsId: TIntegerField;
    DonationDefaultsDateAdded: TDateTimeField;
    DonationDefaultsAddedBy: TIntegerField;
    DonationDefaultsLastUpdatedBy: TIntegerField;
    DonationDefaultsLastUpdated: TDateTimeField;
    DonationDefaultsDonorId: TIntegerField;
    DonationDefaultsDonationKind: TStringField;
    DonationDefaultsUsualDayOfMonth: TIntegerField;
    DonationDefaultsAmount: TFloatField;
    DonationDefaultsPaymentMethod: TStringField;
    DonationDefaultsAnalysisCode1: TStringField;
    DonationDefaultsAnalysisCode2: TStringField;
    DonationDefaultsAnalysisCode3: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure CloseDefaultButtonClick(Sender: TObject);
    procedure SaveDefaultButtonClick(Sender: TObject);
    procedure DonationDefaultsAfterPost(DataSet: TDataSet);
    procedure DonationDefaultsAfterOpen(DataSet: TDataSet);
    procedure DataChange(Sender: TObject);
    procedure DonationDefaultsAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
  private
    { Private declarations }
    FDonorId: integer;
    procedure SetLookups;
    procedure SetDonorId(ADonorId: integer);
    procedure SaveDefaults;
    procedure PopulateForm;
    procedure Refresh;
  public
    { Public declarations }

    property DonorId: integer read FDonorId write SetDonorId;
  protected procedure LoadDFMValues; override; end;

var
  DonationDefaultsForm: TDonationDefaultsForm;

implementation

uses
  MainDataModule;


{$R *.dfm}

procedure TDonationDefaultsForm.CloseDefaultButtonClick(Sender: TObject);
begin
  ModalResult := mrClose;
end;

procedure TDonationDefaultsForm.SetDonorId(ADonorId: integer);
begin
  FDonorId := ADonorId;
  DonationDefaults.Load;
end;

procedure TDonationDefaultsForm.WebFormShow(Sender: TObject);
begin
  SetLookups;
  SaveDefaultButton.Enabled := False;
end;

procedure TDonationDefaultsForm.SetLookups;
begin
  DonationKindDefaultCombo.LookupValues.AddPair('Donation', 'Donation');
  DonationKindDefaultCombo.LookupValues.AddPair('GiveAsYouEarn', 'Give As You Earn');
  DonationKindDefaultCombo.LookupValues.AddPair('PayrollGiving', 'Payroll Giving');
  DonationKindDefaultCombo.LookupValues.AddPair('PayrollGovernmentScheme', 'Payroll Government Scheme');
  DonationKindDefaultCombo.LookupValues.AddPair('Legacy', 'Legacy');
  DonationKindDefaultCombo.LookupValues.AddPair('Other', 'Other');

  PaymentMethodDefaultCombo.LookupValues.AddPair('Cash', 'Cash');
  PaymentMethodDefaultCombo.LookupValues.AddPair('Card', 'Card');
  PaymentMethodDefaultCombo.LookupValues.AddPair('Cheque', 'Cheque');
  PaymentMethodDefaultCombo.LookupValues.AddPair('StandingOrder', 'Standing Order');
  PaymentMethodDefaultCombo.LookupValues.AddPair('DDR', 'DDR');
  PaymentMethodDefaultCombo.LookupValues.AddPair('BankTransfer', 'Bank Transfer');
  PaymentMethodDefaultCombo.LookupValues.AddPair('PayPal', 'PayPal');
  PaymentMethodDefaultCombo.LookupValues.AddPair('WebCard', 'Web Card');
  PaymentMethodDefaultCombo.LookupValues.AddPair('Other', 'Other');

  AnalysisCode1DefaultCombo.LookupValues.AddPair('AnalysisCode1', 'Analysis Code 1');
  AnalysisCode1DefaultCombo.LookupValues.AddPair('AnalysisCode2', 'Analysis Code 2');
  AnalysisCode1DefaultCombo.LookupValues.AddPair('AnalysisCode3', 'Analysis Code 3');
  AnalysisCode1DefaultCombo.LookupValues.AddPair('AnalysisCode4', 'Analysis Code 4');

  AnalysisCode2DefaultCombo.LookupValues.AddPair('AnalysisCode1', 'Analysis Code 1');
  AnalysisCode2DefaultCombo.LookupValues.AddPair('AnalysisCode2', 'Analysis Code 2');
  AnalysisCode2DefaultCombo.LookupValues.AddPair('AnalysisCode3', 'Analysis Code 3');
  AnalysisCode2DefaultCombo.LookupValues.AddPair('AnalysisCode4', 'Analysis Code 4');

  DonationKindDefaultCombo.ItemIndex := -1;
  PaymentMethodDefaultCombo.ItemIndex := -1;
end;


procedure TDonationDefaultsForm.DonationDefaultsAfterApplyUpdates(
  Sender: TDataSet; Info: TResolveResults);
begin
//  inherited;
  Refresh;
end;

procedure TDonationDefaultsForm.DonationDefaultsAfterOpen(DataSet: TDataSet);
begin
  if DonationDefaults.Locate('DonorId', FDonorId, []) then
  begin
    PopulateForm;
    DonationDefaults.Edit
  end
  else
    DonationDefaults.Insert;
end;

procedure TDonationDefaultsForm.DonationDefaultsAfterPost(DataSet: TDataSet);
begin
  //inherited;
  DonationDefaults.ApplyUpdates;
end;

procedure TDonationDefaultsForm.SaveDefaultButtonClick(Sender: TObject);
begin
  SaveDefaults;
  SaveDefaultButton.Enabled := False;
end;

procedure TDonationDefaultsForm.SaveDefaults;
begin
  DonationDefaults.FieldByName('DonorId').AsInteger := FDonorId;

  if DonationKindDefaultCombo.ItemIndex <> -1 then
    DonationDefaults.FieldByName('DonationKind').AsString := DonationKindDefaultCombo.Value;

  if DayOfMonthDefaultEdit.Text <> '' then
    DonationDefaults.FieldByName('UsualDayOfMonth').AsInteger := strtoint(DayOfMonthDefaultEdit.Text);

  if AmountDefaultEdit.Text <> '' then
    DonationDefaults.FieldByName('Amount').AsString := AmountDefaultEdit.Text;
  if PaymentMethodDefaultCombo.ItemIndex <> -1 then
    DonationDefaults.FieldByName('PaymentMethod').AsString := PaymentMethodDefaultCombo.Value;

  if AnalysisCode1DefaultCombo.ItemIndex <> -1 then
    DonationDefaults.FieldByName('AnalysisCode1').AsString := AnalysisCode1DefaultCombo.Value;
  if AnalysisCode2DefaultCombo.ItemIndex <> -1 then
    DonationDefaults.FieldByName('AnalysisCode2').AsString := AnalysisCode2DefaultCombo.Value;
  DonationDefaults.Post;
end;

procedure TDonationDefaultsForm.PopulateForm;
begin
  DonationKindDefaultCombo.Value  := DonationDefaults.FieldByName('DonationKind').AsString;
  DayOfMonthDefaultEdit.Text      := DonationDefaults.FieldByName('UsualDayOfMonth').AsString;
  AmountDefaultEdit.Text          := DonationDefaults.FieldByName('Amount').AsString;
  PaymentMethodDefaultCombo.Value := DonationDefaults.FieldByName('PaymentMethod').AsString;
  AnalysisCode1DefaultCombo.Value := DonationDefaults.FieldByName('AnalysisCode1').AsString;
  AnalysisCode2DefaultCombo.Value := DonationDefaults.FieldByName('AnalysisCode2').AsString;
end;

procedure TDonationDefaultsForm.DataChange(Sender: TObject);
begin
  SaveDefaultButton.Enabled := True;
end;

procedure TDonationDefaultsForm.Refresh;
begin
  if DonationDefaults.Locate('DonorId', FDonorId, []) then
  begin
    PopulateForm;
    DonationDefaults.Edit
  end
  else
    DonationDefaults.Insert;

  //DonationDefaults.Active := False;
  //DonationDefaults.Active := True;
end;

procedure TDonationDefaultsForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  PaymentMethodDefaultCombo := TLookupComboBox.Create('PaymentMethodDefaultCombo');
  AnalysisCode2DefaultCombo := TLookupComboBox.Create('AnalysisCode2DefaultCombo');
  AnalysisCode1DefaultCombo := TLookupComboBox.Create('AnalysisCode1DefaultCombo');
  AmountDefaultEdit := TEdit.Create('AmountDefaultEdit');
  DayOfMonthDefaultEdit := TEdit.Create('DayOfMonthDefaultEdit');
  DonationKindDefaultCombo := TLookupComboBox.Create('DonationKindDefaultCombo');
  SaveDefaultButton := TButton.Create('SaveDefaultButton');
  CancelDefaultButton := TButton.Create('CancelDefaultButton');
  CloseDefaultButton := TButton.Create('CloseDefaultButton');
  DonationDefaults := TXDataWebDataSet.Create(Self);
  DonationDefaultsId := TIntegerField.Create(Self);
  DonationDefaultsDateAdded := TDateTimeField.Create(Self);
  DonationDefaultsAddedBy := TIntegerField.Create(Self);
  DonationDefaultsLastUpdatedBy := TIntegerField.Create(Self);
  DonationDefaultsLastUpdated := TDateTimeField.Create(Self);
  DonationDefaultsDonorId := TIntegerField.Create(Self);
  DonationDefaultsDonationKind := TStringField.Create(Self);
  DonationDefaultsUsualDayOfMonth := TIntegerField.Create(Self);
  DonationDefaultsAmount := TFloatField.Create(Self);
  DonationDefaultsPaymentMethod := TStringField.Create(Self);
  DonationDefaultsAnalysisCode1 := TStringField.Create(Self);
  DonationDefaultsAnalysisCode2 := TStringField.Create(Self);
  DonationDefaultsAnalysisCode3 := TStringField.Create(Self);

  PaymentMethodDefaultCombo.BeforeLoadDFMValues;
  AnalysisCode2DefaultCombo.BeforeLoadDFMValues;
  AnalysisCode1DefaultCombo.BeforeLoadDFMValues;
  AmountDefaultEdit.BeforeLoadDFMValues;
  DayOfMonthDefaultEdit.BeforeLoadDFMValues;
  DonationKindDefaultCombo.BeforeLoadDFMValues;
  SaveDefaultButton.BeforeLoadDFMValues;
  CancelDefaultButton.BeforeLoadDFMValues;
  CloseDefaultButton.BeforeLoadDFMValues;
  DonationDefaults.BeforeLoadDFMValues;
  DonationDefaultsId.BeforeLoadDFMValues;
  DonationDefaultsDateAdded.BeforeLoadDFMValues;
  DonationDefaultsAddedBy.BeforeLoadDFMValues;
  DonationDefaultsLastUpdatedBy.BeforeLoadDFMValues;
  DonationDefaultsLastUpdated.BeforeLoadDFMValues;
  DonationDefaultsDonorId.BeforeLoadDFMValues;
  DonationDefaultsDonationKind.BeforeLoadDFMValues;
  DonationDefaultsUsualDayOfMonth.BeforeLoadDFMValues;
  DonationDefaultsAmount.BeforeLoadDFMValues;
  DonationDefaultsPaymentMethod.BeforeLoadDFMValues;
  DonationDefaultsAnalysisCode1.BeforeLoadDFMValues;
  DonationDefaultsAnalysisCode2.BeforeLoadDFMValues;
  DonationDefaultsAnalysisCode3.BeforeLoadDFMValues;
  try
    Caption := 'Donor Defaults';
    ElementPosition := epIgnore;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    PaymentMethodDefaultCombo.SetParentComponent(Self);
    PaymentMethodDefaultCombo.Name := 'PaymentMethodDefaultCombo';
    PaymentMethodDefaultCombo.Left := 22;
    PaymentMethodDefaultCombo.Top := 144;
    PaymentMethodDefaultCombo.Width := 419;
    PaymentMethodDefaultCombo.Height := 22;
    PaymentMethodDefaultCombo.ElementClassName := 'form-select';
    PaymentMethodDefaultCombo.ElementPosition := epIgnore;
    PaymentMethodDefaultCombo.HeightStyle := ssAuto;
    PaymentMethodDefaultCombo.HeightPercent := 100.000000000000000000;
    PaymentMethodDefaultCombo.WidthStyle := ssAuto;
    PaymentMethodDefaultCombo.WidthPercent := 100.000000000000000000;
    PaymentMethodDefaultCombo.ItemIndex := -1;
    AnalysisCode2DefaultCombo.SetParentComponent(Self);
    AnalysisCode2DefaultCombo.Name := 'AnalysisCode2DefaultCombo';
    AnalysisCode2DefaultCombo.Left := 22;
    AnalysisCode2DefaultCombo.Top := 224;
    AnalysisCode2DefaultCombo.Width := 419;
    AnalysisCode2DefaultCombo.Height := 22;
    AnalysisCode2DefaultCombo.ElementClassName := 'form-select';
    AnalysisCode2DefaultCombo.ElementPosition := epIgnore;
    AnalysisCode2DefaultCombo.HeightStyle := ssAuto;
    AnalysisCode2DefaultCombo.HeightPercent := 100.000000000000000000;
    AnalysisCode2DefaultCombo.WidthStyle := ssAuto;
    AnalysisCode2DefaultCombo.WidthPercent := 100.000000000000000000;
    AnalysisCode2DefaultCombo.ItemIndex := -1;
    AnalysisCode1DefaultCombo.SetParentComponent(Self);
    AnalysisCode1DefaultCombo.Name := 'AnalysisCode1DefaultCombo';
    AnalysisCode1DefaultCombo.Left := 22;
    AnalysisCode1DefaultCombo.Top := 184;
    AnalysisCode1DefaultCombo.Width := 419;
    AnalysisCode1DefaultCombo.Height := 22;
    AnalysisCode1DefaultCombo.ElementClassName := 'form-select';
    AnalysisCode1DefaultCombo.ElementPosition := epIgnore;
    AnalysisCode1DefaultCombo.HeightStyle := ssAuto;
    AnalysisCode1DefaultCombo.HeightPercent := 100.000000000000000000;
    AnalysisCode1DefaultCombo.WidthStyle := ssAuto;
    AnalysisCode1DefaultCombo.WidthPercent := 100.000000000000000000;
    AnalysisCode1DefaultCombo.ItemIndex := -1;
    AmountDefaultEdit.SetParentComponent(Self);
    AmountDefaultEdit.Name := 'AmountDefaultEdit';
    AmountDefaultEdit.Left := 26;
    AmountDefaultEdit.Top := 104;
    AmountDefaultEdit.Width := 121;
    AmountDefaultEdit.Height := 22;
    AmountDefaultEdit.ChildOrder := 10;
    AmountDefaultEdit.ElementClassName := 'form-control';
    AmountDefaultEdit.ElementPosition := epIgnore;
    AmountDefaultEdit.HeightStyle := ssAuto;
    AmountDefaultEdit.HeightPercent := 100.000000000000000000;
    AmountDefaultEdit.WidthStyle := ssAuto;
    AmountDefaultEdit.WidthPercent := 100.000000000000000000;
    DayOfMonthDefaultEdit.SetParentComponent(Self);
    DayOfMonthDefaultEdit.Name := 'DayOfMonthDefaultEdit';
    DayOfMonthDefaultEdit.Left := 24;
    DayOfMonthDefaultEdit.Top := 64;
    DayOfMonthDefaultEdit.Width := 121;
    DayOfMonthDefaultEdit.Height := 22;
    DayOfMonthDefaultEdit.ChildOrder := 10;
    DayOfMonthDefaultEdit.ElementClassName := 'form-control';
    DayOfMonthDefaultEdit.ElementPosition := epIgnore;
    DayOfMonthDefaultEdit.HeightStyle := ssAuto;
    DayOfMonthDefaultEdit.HeightPercent := 100.000000000000000000;
    DayOfMonthDefaultEdit.WidthStyle := ssAuto;
    DayOfMonthDefaultEdit.WidthPercent := 100.000000000000000000;
    DonationKindDefaultCombo.SetParentComponent(Self);
    DonationKindDefaultCombo.Name := 'DonationKindDefaultCombo';
    DonationKindDefaultCombo.Left := 22;
    DonationKindDefaultCombo.Top := 24;
    DonationKindDefaultCombo.Width := 419;
    DonationKindDefaultCombo.Height := 22;
    DonationKindDefaultCombo.ElementClassName := 'form-select';
    DonationKindDefaultCombo.ElementPosition := epIgnore;
    DonationKindDefaultCombo.HeightPercent := 100.000000000000000000;
    DonationKindDefaultCombo.WidthPercent := 100.000000000000000000;
    DonationKindDefaultCombo.ItemIndex := -1;
    SaveDefaultButton.SetParentComponent(Self);
    SaveDefaultButton.Name := 'SaveDefaultButton';
    SaveDefaultButton.Left := 243;
    SaveDefaultButton.Top := 272;
    SaveDefaultButton.Width := 96;
    SaveDefaultButton.Height := 25;
    SaveDefaultButton.Caption := 'Save';
    SaveDefaultButton.ChildOrder := 6;
    SaveDefaultButton.ElementClassName := 'btn';
    SaveDefaultButton.HeightPercent := 100.000000000000000000;
    SaveDefaultButton.WidthPercent := 100.000000000000000000;
    SetEvent(SaveDefaultButton, Self, 'OnClick', 'SaveDefaultButtonClick');
    CancelDefaultButton.SetParentComponent(Self);
    CancelDefaultButton.Name := 'CancelDefaultButton';
    CancelDefaultButton.Left := 141;
    CancelDefaultButton.Top := 272;
    CancelDefaultButton.Width := 96;
    CancelDefaultButton.Height := 25;
    CancelDefaultButton.Caption := 'Cancel';
    CancelDefaultButton.ChildOrder := 6;
    CancelDefaultButton.ElementClassName := 'btn';
    CancelDefaultButton.HeightPercent := 100.000000000000000000;
    CancelDefaultButton.WidthPercent := 100.000000000000000000;
    CloseDefaultButton.SetParentComponent(Self);
    CloseDefaultButton.Name := 'CloseDefaultButton';
    CloseDefaultButton.Left := 345;
    CloseDefaultButton.Top := 272;
    CloseDefaultButton.Width := 96;
    CloseDefaultButton.Height := 25;
    CloseDefaultButton.Caption := 'Close';
    CloseDefaultButton.ChildOrder := 6;
    CloseDefaultButton.ElementClassName := 'btn';
    CloseDefaultButton.ElementFont := efCSS;
    CloseDefaultButton.ElementPosition := epIgnore;
    CloseDefaultButton.HeightStyle := ssAuto;
    CloseDefaultButton.HeightPercent := 100.000000000000000000;
    CloseDefaultButton.WidthStyle := ssAuto;
    CloseDefaultButton.WidthPercent := 100.000000000000000000;
    SetEvent(CloseDefaultButton, Self, 'OnClick', 'CloseDefaultButtonClick');
    DonationDefaults.SetParentComponent(Self);
    DonationDefaults.Name := 'DonationDefaults';
    DonationDefaults.AfterOpen := DonationDefaultsAfterOpen;
    DonationDefaults.AfterPost := DonationDefaultsAfterPost;
    DonationDefaults.EntitySetName := 'DonationDefaults';
    DonationDefaults.Connection := MainData.DataConnection;
    DonationDefaults.Left := 464;
    DonationDefaults.Top := 344;
    DonationDefaultsId.SetParentComponent(DonationDefaults);
    DonationDefaultsId.Name := 'DonationDefaultsId';
    DonationDefaultsId.FieldName := 'Id';
    DonationDefaultsDateAdded.SetParentComponent(DonationDefaults);
    DonationDefaultsDateAdded.Name := 'DonationDefaultsDateAdded';
    DonationDefaultsDateAdded.FieldName := 'DateAdded';
    DonationDefaultsAddedBy.SetParentComponent(DonationDefaults);
    DonationDefaultsAddedBy.Name := 'DonationDefaultsAddedBy';
    DonationDefaultsAddedBy.FieldName := 'AddedBy';
    DonationDefaultsLastUpdatedBy.SetParentComponent(DonationDefaults);
    DonationDefaultsLastUpdatedBy.Name := 'DonationDefaultsLastUpdatedBy';
    DonationDefaultsLastUpdatedBy.FieldName := 'LastUpdatedBy';
    DonationDefaultsLastUpdated.SetParentComponent(DonationDefaults);
    DonationDefaultsLastUpdated.Name := 'DonationDefaultsLastUpdated';
    DonationDefaultsLastUpdated.FieldName := 'LastUpdated';
    DonationDefaultsDonorId.SetParentComponent(DonationDefaults);
    DonationDefaultsDonorId.Name := 'DonationDefaultsDonorId';
    DonationDefaultsDonorId.FieldName := 'DonorId';
    DonationDefaultsDonationKind.SetParentComponent(DonationDefaults);
    DonationDefaultsDonationKind.Name := 'DonationDefaultsDonationKind';
    DonationDefaultsDonationKind.FieldName := 'DonationKind';
    DonationDefaultsDonationKind.Size := 30;
    DonationDefaultsUsualDayOfMonth.SetParentComponent(DonationDefaults);
    DonationDefaultsUsualDayOfMonth.Name := 'DonationDefaultsUsualDayOfMonth';
    DonationDefaultsUsualDayOfMonth.FieldName := 'UsualDayOfMonth';
    DonationDefaultsAmount.SetParentComponent(DonationDefaults);
    DonationDefaultsAmount.Name := 'DonationDefaultsAmount';
    DonationDefaultsAmount.FieldName := 'Amount';
    DonationDefaultsPaymentMethod.SetParentComponent(DonationDefaults);
    DonationDefaultsPaymentMethod.Name := 'DonationDefaultsPaymentMethod';
    DonationDefaultsPaymentMethod.FieldName := 'PaymentMethod';
    DonationDefaultsAnalysisCode1.SetParentComponent(DonationDefaults);
    DonationDefaultsAnalysisCode1.Name := 'DonationDefaultsAnalysisCode1';
    DonationDefaultsAnalysisCode1.FieldName := 'AnalysisCode1';
    DonationDefaultsAnalysisCode1.Size := 75;
    DonationDefaultsAnalysisCode2.SetParentComponent(DonationDefaults);
    DonationDefaultsAnalysisCode2.Name := 'DonationDefaultsAnalysisCode2';
    DonationDefaultsAnalysisCode2.FieldName := 'AnalysisCode2';
    DonationDefaultsAnalysisCode2.Size := 75;
    DonationDefaultsAnalysisCode3.SetParentComponent(DonationDefaults);
    DonationDefaultsAnalysisCode3.Name := 'DonationDefaultsAnalysisCode3';
    DonationDefaultsAnalysisCode3.FieldName := 'AnalysisCode3';
    DonationDefaultsAnalysisCode3.Size := 75;
  finally
    PaymentMethodDefaultCombo.AfterLoadDFMValues;
    AnalysisCode2DefaultCombo.AfterLoadDFMValues;
    AnalysisCode1DefaultCombo.AfterLoadDFMValues;
    AmountDefaultEdit.AfterLoadDFMValues;
    DayOfMonthDefaultEdit.AfterLoadDFMValues;
    DonationKindDefaultCombo.AfterLoadDFMValues;
    SaveDefaultButton.AfterLoadDFMValues;
    CancelDefaultButton.AfterLoadDFMValues;
    CloseDefaultButton.AfterLoadDFMValues;
    DonationDefaults.AfterLoadDFMValues;
    DonationDefaultsId.AfterLoadDFMValues;
    DonationDefaultsDateAdded.AfterLoadDFMValues;
    DonationDefaultsAddedBy.AfterLoadDFMValues;
    DonationDefaultsLastUpdatedBy.AfterLoadDFMValues;
    DonationDefaultsLastUpdated.AfterLoadDFMValues;
    DonationDefaultsDonorId.AfterLoadDFMValues;
    DonationDefaultsDonationKind.AfterLoadDFMValues;
    DonationDefaultsUsualDayOfMonth.AfterLoadDFMValues;
    DonationDefaultsAmount.AfterLoadDFMValues;
    DonationDefaultsPaymentMethod.AfterLoadDFMValues;
    DonationDefaultsAnalysisCode1.AfterLoadDFMValues;
    DonationDefaultsAnalysisCode2.AfterLoadDFMValues;
    DonationDefaultsAnalysisCode3.AfterLoadDFMValues;
  end;
end;

end.